<template>
    <div class="header">
        Lyrai's Favorite Characters
    </div>
</template>

<script>
export default {
  name: 'Header',
  components: {
  }
}
</script>

<style scoped>
.header {
    margin: 20px;
    text-align: center;
    font-size: 45px;
}
</style>